import React from 'react';

import styles from 'css-module/components/subdomain/admin/v2/_AdminV2CustomIdeaFieldModal.module.scss';

type FormFieldProps = {
  label: string;
  required?: boolean;
  children: React.ReactNode;
};

export default function FormField({ label, required, children }: FormFieldProps) {
  return (
    <div className={styles.fieldGroup}>
      <label>
        {label} {required && <span className={styles.required}>*</span>}
      </label>
      {children}
    </div>
  );
}
